import { formatInTimeZone } from "date-fns-tz";
import { type FC, useMemo } from "react";

import type { DocumentMetadata } from "@moment/api-collab/api-types";

import { Row } from "../../layout/row/Row";

export const DocumentCreatedDate: FC<{ documentMetadata: DocumentMetadata }> = ({
	documentMetadata,
}) => {
	const date = useMemo(
		() => formatInTimeZone(documentMetadata.created, "UTC", "MMM d, yyyy"),
		[documentMetadata.created]
	);

	return (
		<div className="rich-text mt-8 -mb-6">
			<Row>
				<div className="text-secondary text-base uppercase border-l-2 -ml-4 pl-4 border-brand">
					{date}
				</div>
			</Row>
		</div>
	);
};
